<app-credit-card-info 
    *ngIf="(paymentTypeSelected == card_payment)"
    data-auto-id="add-payment-credit-card-info"
></app-credit-card-info>

<app-bank-account-info 
    *ngIf="(paymentTypeSelected == bank_acc_payment)"
    data-auto-id="add-payment-bank-account-info"
></app-bank-account-info>

<app-billing-address-info
    data-auto-id="add-payment-billing-address-info"
></app-billing-address-info>

<div 
    *ngIf="paymentInitiatedFlow === pastDueFlow"
    data-auto-id="add-payment-bank-account-disclaimer"
>
    <p-divider></p-divider>
    <div class="text-sm">
        <p data-auto-id="add-payment-disclaimer-content-monthly" *ngIf="billingType==='MONTHLY'">
            Your {{paymentTypeSelected === card_payment ? creditCardLabel : bankAccountLabel}} will be saved for future re-occurring payments. 
            Billing will continue on {{billingDay}} of each month for {{ chargeAmount | currency:'USD':'symbol-narrow'}}/month (subject to applicable discounts).
        </p>

        <p data-auto-id="add-payment-disclaimer-content-annually" *ngIf="billingType==='ANNUAL'">
            Your {{paymentTypeSelected === card_payment ? creditCardLabel : bankAccountLabel}} will be securely saved for future re-occurring payments. A reminder notice will be sent to you
                 at least 45 days prior to your renewal date and recurring payment.
        </p>
        <p>{{lockSymbol}} {{ secureEncryptionMessage }}</p>
    </div>
</div>
